<template>
    <div class="revista">
        <div class="container-fluid" v-if="periodico && tipoPeriodico && lstPeriodicoMateria.length > 0">

            <!-- TOP BAR -->
            <div class="linha-topo">
                <div class="btn-back" @click="voltar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
                    Voltar
                </div>
                <div class="titulo-revista">
                    <span v-if="periodico">{{ periodico.dsTitulo }}</span>
                </div>
                <div class="topbar-meta">
                    <span>{{ formatDate(periodico.dtPublicacao) }}</span>
                    <span class="meta-dot"></span>
                    <span>Ed. {{ periodico.nrPeriodico }}</span>
                </div>
            </div>

            <!-- LAYOUT -->
            <div class="conteudo">

                <!-- SIDEBAR -->
                <div class="nav-materias">
                    <div class="sidebar-header">
                        <div class="sidebar-big">Sumário</div>
                    </div>
                    <nav class="scroll-nav">
                        <ul class="nav-list">
                            <li v-for="(item, index) in lstPeriodicoMateria" :key="index">
                                <a :class="'nav-link' + (materiaAtiva === index ? ' active' : '')"
                                   @click="scrolToDiv('materia-' + index)">
                                    <div class="nav-accent"></div>
                                    <div class="nav-inner">
                                        <span class="nav-tag" v-if="item.tipoPeriodicoMateria.nmTipoPeriodicoMateria">
                                            {{ item.tipoPeriodicoMateria.nmTipoPeriodicoMateria }}
                                        </span>
                                        <div class="nav-text">{{ item.dsTitulo }}</div>
                                        <span class="nav-page">pág. {{ index + 2 }}</span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <!-- MAIN CONTENT -->
                <div class="colunas" id="colunas" v-scroll="handleScroll">
                    <div class="content-inner">

                        <!-- CAPA -->
                        <div class="cover-section">
                            <div class="cover-frame">
                                <img :src="periodico.urlImgPeriodico" class="cover-img" v-if="periodico.urlImgPeriodico" />
                                <div class="cover-placeholder" v-else>
                                    <div class="cp-title">{{ tipoPeriodico.nmTipoPeriodico }}</div>
                                    <div class="cp-line"></div>
                                    <div class="cp-date">{{ formatDate(periodico.dtPublicacao) }}</div>
                                </div>
                                <div class="cover-badge">
                                    <small>Edição</small>
                                    {{ periodico.nrPeriodico }}
                                </div>
                            </div>
                        </div>

                        <!-- MASTHEAD / CONTRACAPA -->
                        <div class="masthead">
                            <div class="masthead-title">{{ periodico.dsTitulo }}</div>
                            <div class="masthead-kicker">{{ tipoPeriodico.nmTipoPeriodico }}</div>
                            <p class="masthead-desc">{{ periodico.dsPeriodico }}</p>

                            <div class="masthead-grid">
                                <div class="mf">
                                    <label>Presidente</label>
                                    <p>Rudimar Reis</p>
                                </div>
                                <div class="mf">
                                    <label>Vice-Presidente</label>
                                    <p>Ruimar Reis</p>
                                </div>
                                <div class="mf">
                                    <label>Editora-Chefe</label>
                                    <p>Aline de Oliveira</p>
                                    <a href="mailto:aline@negociospublicos.com.br">DRT 8796/PR</a>
                                </div>
                                <div class="mf" v-if="periodico.dsColaboradores">
                                    <label>Colaboradores</label>
                                    <p>{{ periodico.dsColaboradores }}</p>
                                </div>
                            </div>

                            <div class="mdivider"></div>

                            <p class="masthead-legal">
                                <strong>Restrições ao Uso de Materiais —</strong>
                                Este produto pertence e é operado pela Editora Negócios Públicos do Brasil, não podendo ser copiado,
                                reproduzido, republicado, transmitido ou distribuído para fins comerciais. Modificar matérias ou usá-las
                                para qualquer outro propósito é violação dos direitos autorais, conforme normas da ABNT e art. 184 do
                                Código Penal Brasileiro. Permissão deve ser obtida via
                                <a href="mailto:falecom@negociospublicos.com.br">falecom@negociospublicos.com.br</a>.
                            </p>

                            <div class="issn-row">
                                <span class="issn-badge">ISSN 1984-2589</span>
                                <span class="edition-tag">{{ formatDate(periodico.dtPublicacao) }} · Edição nº {{ periodico.nrPeriodico }}</span>
                            </div>

                            <div class="editorial-box" v-html="periodico.dsEditorial"></div>

                            <div class="addr-block">
                                Editora Negócios Públicos do Brasil<br>
                                R. Dr. Brasilio Vicente de Castro, 111 — 9º, 10º e 12º andar<br>
                                Campo Comprido, Curitiba/PR · CEP 81.200-526 · Tel. (41) 3778-1700
                            </div>
                        </div>

                        <!-- SUMÁRIO -->
                        <div class="sumario-card">
                            <div class="sum-header">
                                <span class="sum-title">Sumário</span>
                                <span class="sum-count">{{ lstPeriodicoMateria.length }} matérias</span>
                            </div>
                            <div v-for="(item, index) in lstPeriodicoMateria" :key="index"
                                 class="sum-row"
                                 @click="scrolToDiv('materia-' + index)">
                                <span class="sum-num">{{ String(index + 1).padStart(2, '0') }}</span>
                                <span class="sum-text">{{ item.dsTitulo }}</span>
                                <span class="sum-page">pág. {{ index + 2 }}</span>
                                <svg class="sum-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                            </div>
                        </div>

                        <!-- MATÉRIAS -->
                        <div class="materia-block"
                             :id="'materia-' + index"
                             v-for="(item, index) in lstPeriodicoMateria"
                             :key="index">

                            <div class="sec-hdr">
                                <span class="sec-tag">// {{ item.tipoPeriodicoMateria.nmTipoPeriodicoMateria }}</span>
                                <div class="sec-rule"></div>
                            </div>

                            <div class="mat-head">
                                <span class="mat-tipo" v-if="item.tipoPeriodicoMateria.nmTipoPeriodicoMateria">
                                    {{ item.tipoPeriodicoMateria.nmTipoPeriodicoMateria }}
                                </span>
                                <h1 class="mat-title">{{ item.dsTitulo }}</h1>
                                <div class="mat-sub" v-if="item.dsSubtitulo">{{ item.dsSubtitulo }}</div>
                            </div>

                            <div class="mat-body">
                                <div class="htmlMateria" v-html="item.htmlMateria"></div>
                            </div>

                            <div class="mat-footer">
                                <span class="mat-pub">{{ periodico.dsTitulo }} · {{ periodico.nrAno }}</span>
                                <div class="page-num">{{ index + 2 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro } from '@/config/global'
    import { sanitizeHtmlMateriaParaExibicao } from '@/utils/materiaHtmlPeriodico'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'Revista',
        components: {},
        data: function () {
            return {
                periodico: null,
                tipoPeriodico: null,
                lstPeriodicoMateria: [],
                materiaAtiva: null,
            }
        },
        props: ['idPeriodico'],
        methods: {
            voltar() {
                // Sem histórico (aba nova ou URL direta) o go(-1) não faz nada.
                if (window.history.state && window.history.state.back) {
                    this.$router.go(-1);
                    return;
                }

                this.$router.push({ name: 'Periodicos' });
            },

            formatDate(date) {
                return moment(date).format('MM/YYYY');
            },

            getMes(date) {
                return moment(date).format('MM');
            },

            getClassTipoPeriodico(nmTipoPeriodico) {
                if (nmTipoPeriodico.includes('Licicon')) return 'licicon';
                if (nmTipoPeriodico.includes('Pregoeiro')) return 'pregoeiro';
                if (nmTipoPeriodico.includes('Negócios')) return 'np';
                if (nmTipoPeriodico.includes('Governança')) return 'governanca';
                return 'none';
            },

            load() {
                let $this = this;
                axios.get(`${urlApi}/Periodico/GetRevista`, { params: { idPeriodico: $this.idPeriodico } })
                    .then(res => {
                        if (res.data.success) {
                            var dados = res.data.data;
                            $this.periodico = dados.periodico;
                            dados.tipoPeriodico.classe = $this.getClassTipoPeriodico(dados.tipoPeriodico.nmTipoPeriodico);
                            $this.tipoPeriodico = dados.tipoPeriodico;
                            $this.lstPeriodicoMateria = dados.lstPeriodicoMateria.map(item => ({
                                ...item,
                                htmlMateria: sanitizeHtmlMateriaParaExibicao(
                                    item.htmlMateria != null ? item.htmlMateria : item.HtmlMateria != null ? item.HtmlMateria : '',
                                    urlApi,
                                ),
                            }));
                            
                            $this.$nextTick(() => {
                                if ($this.$route.query.materia != undefined) {
                                    $this.scrolToDiv('materia-' + $this.$route.query.materia);
                                }
                            });
                        } else {
                            avisoErro("Não foi possível carregar a revista");
                            $this.periodico = null;
                            $this.tipoPeriodico = null;
                            $this.lstPeriodicoMateria = [];
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar a revista");
                        $this.periodico = null;
                        $this.tipoPeriodico = null;
                        $this.lstPeriodicoMateria = [];
                    });
            },

            scrolToDiv(id) {
                document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
            },

            handleScroll(evt) {
                var scroll = evt.target.scrollTop;

                if (scroll < 1000) {
                    this.materiaAtiva = null;
                }

                for (let i = 0; i < this.lstPeriodicoMateria.length; i++) {
                    var divMateria = document.getElementById('materia-' + i);
                    if (scroll > (divMateria.offsetTop - 200) && scroll < ((divMateria.offsetHeight - 200) + divMateria.offsetTop)) {
                        this.materiaAtiva = i;
                    }
                }
            },
        },
        mounted: function () {
            if (this.idPeriodico) {
                axios.post(`${urlApi}/LogSollicita/LogPeriodico`, { 'idPeriodico': this.idPeriodico });
            }
            this.load();
        },
    };
</script>

<style lang="scss" scoped>

    $warm-white: #fdfcf9;
    $warm-off: #f5f2eb;
    $warm-mid: #ede9df;
    $gold: #C8922A;
    $gold-light: #E8A83A;
    $gold-pale: #fdf0d5;
    $dark: #1A1A2E;
    $dark-mid: #2a2a42;
    $muted: #7a7060;
    $border: #DEDBD4;
    $border-gold: rgba(200, 146, 42, 0.25);
    $sidebar-w: 270px;
    $topbar-h: 54px;

    .htmlMateria {
        color: #000;
    }

    /* ── RESET BASE ── */
    .revista {
        background: $warm-off;
        font-family: 'Crimson Pro', 'Georgia', serif;
        height: 100vh;
        overflow: hidden;
    }

    .container-fluid {
        line-height: initial;
        height: 100vh;
        overflow: hidden;
    }

    footer {
        visibility: hidden;
    }

    /* ── TOPBAR ── */
    .linha-topo {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: $topbar-h;
        background: $dark;
        border-bottom: 1px solid $border-gold;
        display: flex;
        align-items: center;
        z-index: 100;
        padding: 0 24px;
        gap: 20px;

        &::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            height: 1px;
            background: linear-gradient(90deg, transparent, $gold 40%, transparent);
        }
    }

    .btn-back {
        display: flex;
        align-items: center;
        gap: 8px;
        color: rgba(255,255,255,0.55);
        font-family: 'DM Mono', monospace;
        font-size: 10px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        background: none;
        border: 1px solid rgba(255,255,255,0.18);
        border-radius: 4px;
        padding: 6px 14px;
        cursor: pointer;
        transition: all 0.2s;
        white-space: nowrap;

        svg {
            width: 11px;
            height: 11px;
            flex-shrink: 0;
        }

        &:hover {
            color: $gold-light;
            border-color: $border-gold;
            background: rgba(200, 146, 42, 0.08);
        }
    }

    .titulo-revista {
        flex: 1;
        text-align: center;
        font-family: 'Playfair Display', serif;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.03em;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        box-shadow: none;
        z-index: auto;
    }

    .topbar-meta {
        font-family: 'DM Mono', monospace;
        font-size: 10px;
        color: rgba(255,255,255,0.45);
        white-space: nowrap;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .meta-dot {
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: $gold;
        opacity: 0.7;
        display: inline-block;
    }

    /* ── LAYOUT ── */
    .conteudo {
        display: flex;
        height: 100vh;
        padding-top: $topbar-h;
        background-color: $warm-off;
        max-height: 100vh;
    }

    /* ── SIDEBAR ── */
    .nav-materias {
        width: $sidebar-w;
        flex-shrink: 0;
        background: #fff;
        border-right: 1px solid $border;
        overflow-y: auto;
        height: 100%;
        scrollbar-width: thin;
        scrollbar-color: $border-gold transparent;
        box-shadow: 2px 0 8px rgba(26,26,46,0.06);

        &::-webkit-scrollbar {
            width: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: $border-gold;
            border-radius: 2px;
        }
    }

    .sidebar-header {
        padding: 24px 20px 14px;
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 2;
        border-bottom: 1px solid $border;
    }

    .sidebar-label {
        font-family: 'DM Mono', monospace;
        font-size: 9px;
        letter-spacing: 0.18em;
        text-transform: uppercase;
        color: $gold;
        opacity: 0.85;
        display: block;
        margin-bottom: 2px;
    }

    .sidebar-big {
        font-family: 'Playfair Display', serif;
        font-size: 34px;
        font-weight: 900;
        color: $dark;
        line-height: 0.9;
        user-select: none;
    }

    .titulo-nav {
        display: none;
    }

    .nav-list {
        list-style: none;
        padding: 8px 0 24px;
        margin: 0;
    }

    .nav-link {
        display: flex;
        align-items: stretch;
        cursor: pointer;
        text-decoration: none;
        transition: background 0.15s;
        border-bottom: 1px solid rgba(0,0,0,0.04);

        &:hover {
            background: rgba(200, 146, 42, 0.06);
        }

        &.active {
            background: rgba(200, 146, 42, 0.1);
        }

        &:hover .nav-accent {
            background: rgba(200, 146, 42, 0.4);
        }

        &.active .nav-accent {
            background: $gold;
        }

        &:hover .nav-text {
            color: $dark;
        }

        &.active .nav-text {
            color: $dark;
        }

        &.active .nav-page {
            color: $gold;
        }
    }

    .nav-accent {
        width: 3px;
        background: transparent;
        flex-shrink: 0;
        transition: background 0.15s;
    }

    .nav-inner {
        padding: 11px 15px;
        flex: 1;
    }

    .nav-tag {
        font-family: 'DM Mono', monospace;
        font-size: 8.5px;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: $gold;
        opacity: 0.75;
        display: block;
        margin-bottom: 3px;
    }

    .nav-text {
        font-family: 'Crimson Pro', serif;
        font-size: 13.5px;
        color: $muted;
        line-height: 1.35;
        transition: color 0.15s;
    }

    .nav-page {
        font-family: 'DM Mono', monospace;
        font-size: 9px;
        color: $gold;
        opacity: 0.75;
        margin-top: 3px;
        display: block;
    }

    /* ── MAIN CONTENT ── */
    .colunas {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        height: 100%;
        scrollbar-width: thin;
        scrollbar-color: $border-gold transparent;
        max-height: 100%;
        background: $warm-off;

        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: $border-gold;
            border-radius: 2px;
        }
    }

    .content-inner {
        max-width: 100%;
        margin: 0 auto;
        padding: 44px 44px 80px;
    }

    /* ── CAPA ── */
    .cover-section {
        display: flex;
        justify-content: center;
        margin-bottom: 52px;
        animation: fadeUp 0.5s ease both;
        background: transparent;
        padding: 0;
    }

    .cover-frame {
        position: relative;
        display: inline-block;

        &::before {
            content: '';
            position: absolute;
            inset: -14px;
            border: 1px solid $border-gold;
            border-radius: 4px;
            pointer-events: none;
        }

        &::after {
            content: '';
            position: absolute;
            inset: -7px;
            border: 1px solid rgba(200,146,42,0.1);
            border-radius: 2px;
            pointer-events: none;
        }
    }

    .cover-img {
        display: block;
        width: 320px;
        border-radius: 2px;
        box-shadow: 0 28px 70px rgba(26,26,46,0.3), 0 8px 20px rgba(26,26,46,0.15);
    }

    .cover-placeholder {
        width: 240px;
        height: 320px;
        background: linear-gradient(155deg, $dark-mid 0%, $dark 100%);
        border-radius: 2px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-shadow: 0 28px 70px rgba(26,26,46,0.3);
        border: 1px solid $border-gold;
    }

    .cp-title {
        font-family: 'Playfair Display', serif;
        font-size: 30px;
        font-weight: 900;
        color: $gold-light;
        letter-spacing: -0.01em;
        text-align: center;
        padding: 0 16px;
    }

    .cp-line {
        width: 60px;
        height: 1px;
        background: $gold;
        opacity: 0.3;
        margin: 14px 0;
    }

    .cp-date {
        font-family: 'DM Mono', monospace;
        font-size: 11px;
        color: rgba(200,146,42,0.5);
    }

    .cover-badge {
        position: absolute;
        bottom: -20px;
        right: -20px;
        background: #fff;
        border: 1px solid $border-gold;
        padding: 9px 16px;
        border-radius: 4px;
        font-family: 'DM Mono', monospace;
        font-size: 21px;
        font-weight: 500;
        color: $gold;
        box-shadow: 0 8px 24px rgba(26,26,46,0.12);
        text-align: center;

        small {
            display: block;
            font-size: 8.5px;
            letter-spacing: 0.14em;
            text-transform: uppercase;
            color: $muted;
            margin-bottom: 1px;
        }
    }

    /* ── MASTHEAD ── */
    .masthead {
        background: #fff;
        border: 1px solid $border;
        border-radius: 8px;
        padding: 34px 38px;
        margin-bottom: 40px;
        position: relative;
        overflow: hidden;
        animation: fadeUp 0.5s 0.08s ease both;
        box-shadow: 0 2px 8px rgba(26,26,46,0.06);

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, transparent, $gold 50%, transparent);
        }
    }

    .masthead-title {
        font-family: 'Playfair Display', serif;
        font-size: 24px;
        font-weight: 700;
        color: $dark;
        margin-bottom: 4px;
    }

    .masthead-kicker {
        font-family: 'DM Mono', monospace;
        font-size: 10px;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: $gold;
        opacity: 0.85;
        margin-bottom: 18px;
    }

    .masthead-desc {
        font-size: 15px;
        color: $muted;
        line-height: 1.65;
        margin-bottom: 26px;
        font-style: italic;
    }

    .masthead-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 14px;
        margin-bottom: 24px;
    }

    .mf {
        label {
            font-family: 'DM Mono', monospace;
            font-size: 8.5px;
            letter-spacing: 0.17em;
            text-transform: uppercase;
            color: $gold;
            opacity: 0.75;
            display: block;
            margin-bottom: 3px;
        }

        p {
            font-size: 13px;
            color: $dark;
            line-height: 1.45;
            margin-bottom: 2px;
        }

        a {
            color: $muted;
            font-size: 11px;
            text-decoration: none;

            &:hover {
                color: $gold;
            }
        }
    }

    .mdivider {
        height: 1px;
        background: linear-gradient(90deg, $border-gold, transparent);
        margin: 20px 0;
    }

    .masthead-legal {
        font-size: 11.5px;
        color: $dark;
        line-height: 1.75;

        strong {
            color: $gold;
            font-weight: 600;
        }

        a {
            color: $gold;
        }
    }

    .issn-row {
        margin-top: 18px;
        display: flex;
        align-items: center;
        gap: 14px;
        flex-wrap: wrap;
    }

    .issn-badge {
        font-family: 'DM Mono', monospace;
        font-size: 11px;
        color: $gold;
        border: 1px solid $border-gold;
        padding: 3px 11px;
        border-radius: 3px;
        letter-spacing: 0.05em;
    }

    .edition-tag {
        font-family: 'DM Mono', monospace;
        font-size: 10px;
        color: $muted;
        text-transform: uppercase;
        letter-spacing: 0.1em;
    }

    .editorial-box {
        background: $gold-pale;
        border-left: 3px solid $gold;
        border-radius: 0 5px 5px 0;
        padding: 20px 24px;
        margin-top: 18px;
        font-size: 14.5px;
        color: $dark;
        line-height: 1.8;
        font-style: italic;

        p {
            color: $dark-mid;
            margin-bottom: 8px;
        }
    }

    .addr-block {
        margin-top: 18px;
        text-align: right;
        font-family: 'DM Mono', monospace;
        font-size: 11px;
        color: $gold;
        line-height: 1.9;
    }

    /* ── SECTION HEADER ── */
    .sec-hdr {
        display: flex;
        align-items: center;
        gap: 14px;
        margin-bottom: 20px;
    }

    .sec-tag {
        font-family: 'DM Mono', monospace;
        font-size: 9.5px;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: $gold;
        white-space: nowrap;
    }

    .sec-rule {
        flex: 1;
        height: 1px;
        background: linear-gradient(90deg, $border-gold, transparent);
    }

    /* ── SUMÁRIO ── */
    .sumario-card {
        background: #fff;
        border: 1px solid $border;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 40px;
        animation: fadeUp 0.5s 0.12s ease both;
        box-shadow: 0 2px 8px rgba(26,26,46,0.06);
    }

    .sum-header {
        padding: 18px 26px 14px;
        border-bottom: 1px solid $border;
        display: flex;
        align-items: baseline;
        gap: 12px;
    }

    .sum-title {
        font-family: 'Playfair Display', serif;
        font-size: 20px;
        font-weight: 700;
        color: $dark;
    }

    .sum-count {
        font-family: 'DM Mono', monospace;
        font-size: 10px;
        color: $muted;
    }

    .sum-row {
        display: flex;
        align-items: center;
        padding: 13px 26px;
        border-bottom: 1px solid rgba(0,0,0,0.04);
        cursor: pointer;
        transition: background 0.15s;
        gap: 14px;

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            background: rgba(200, 146, 42, 0.05);
        }

        &:hover .sum-text {
            color: $dark;
        }

        &:hover .sum-arr {
            transform: translateX(3px);
            color: $gold;
        }
    }

    .sum-num {
        font-family: 'DM Mono', monospace;
        font-size: 11px;
        color: $gold;
        width: 26px;
        flex-shrink: 0;
    }

    .sum-text {
        flex: 1;
        font-size: 14.5px;
        color: $muted;
        transition: color 0.15s;
        line-height: 1.4;
    }

    .sum-page {
        font-family: 'DM Mono', monospace;
        font-size: 10px;
        color: $gold;
        flex-shrink: 0;
    }

    .sum-arr {
        width: 14px;
        height: 14px;
        color: rgba(200, 146, 42, 0.35);
        flex-shrink: 0;
        transition: transform 0.15s, color 0.15s;
    }

    /* ── MATÉRIA ── */
    .materia-block {
        margin-bottom: 44px;
        animation: fadeUp 0.45s ease both;
    }

    .mat-head {
        background: linear-gradient(140deg, $warm-mid, $warm-off);
        border: 1px solid $border;
        border-bottom: none;
        border-radius: 8px 8px 0 0;
        padding: 26px 34px 22px;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, $gold, $gold-light, $gold);
        }
    }

    .mat-tipo {
        font-family: 'DM Mono', monospace;
        font-size: 9px;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: $gold;
        opacity: 0.85;
        margin-bottom: 9px;
        display: block;
    }

    .mat-title {
        font-family: 'Playfair Display', serif;
        font-size: 22px;
        font-weight: 700;
        color: $dark;
        line-height: 1.25;
        margin-bottom: 0;
    }

    .mat-sub {
        margin-top: 11px;
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 15px;
        font-style: italic;
        color: $gold;

        &::after {
            content: '';
            flex: 1;
            height: 1px;
            background: linear-gradient(90deg, $border-gold, transparent);
        }
    }

    .mat-body {
        background: $warm-white;
        border: 1px solid $border;
        border-top: none;
        border-radius: 0 0 8px 8px;
        padding: 32px 38px;

        p {
            font-family: 'Crimson Pro', serif;
            font-size: 16.5px;
            line-height: 1.82;
            color: #252535;
            margin-bottom: 15px;
        }

        h1, h2, h3, h4 {
            font-family: 'Playfair Display', serif;
            color: $dark;
            margin: 22px 0 10px;
        }

        h2 {
            font-size: 19px;
        }

        h3 {
            font-size: 16px;
        }

        blockquote {
            border-left: 3px solid $gold;
            margin: 20px 0;
            padding: 11px 18px;
            background: $gold-pale;
            font-style: italic;
            color: $dark-mid;
            border-radius: 0 4px 4px 0;
            font-size: 15.5px;
            line-height: 1.7;
        }

        ul, ol {
            margin: 0 0 15px 22px;
        }

        li {
            font-family: 'Crimson Pro', serif;
            font-size: 16px;
            line-height: 1.9;
            color: #252535;
        }

        table {
            width: 100%;
            border-collapse: collapse;
            margin: 18px 0;
            font-size: 13px;
            word-break: break-word;
            max-width: 100%;
        }

        th {
            background: $dark;
            color: $gold-light !important;
            padding: 9px 13px;
            text-align: left;
            font-family: 'DM Mono', monospace;
            font-size: 10px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
        }

        td {
            padding: 8px 13px;
            border-bottom: 1px solid $border;
            color: #252535;
        }

        tr:nth-child(even) td {
            background: $warm-off;
        }
    }

    .htmlMateria {
        overflow-wrap: break-word;
        word-break: break-word;

        ::v-deep img,
        ::v-deep iframe,
        ::v-deep table,
        ::v-deep video {
            max-width: 100%;
        }

        ::v-deep img {
            width: auto;
            height: auto;
            display: block;
            margin: 20px auto;
            object-fit: contain;
        }
    }

    .mat-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 2px 0;
    }

    .mat-pub {
        font-family: 'DM Mono', monospace;
        font-size: 10px;
        color: rgba(122, 112, 96, 0.6);
    }

    .page-num {
        font-family: 'DM Mono', monospace;
        font-size: 12px;
        color: $muted;
        background: #fff;
        border: 1px solid $border;
        width: 34px;
        height: 34px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* ── ANIMAÇÃO ── */
    @keyframes fadeUp {
        from {
            opacity: 0;
            transform: translateY(14px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* ── RESPONSIVE ── */
    @media (max-width: 991.98px) {
        .nav-materias {
            width: 220px;
        }

        .content-inner {
            padding: 32px 28px 60px;
        }
    }

    @media (max-width: 767.98px) {
        .nav-materias {
            display: none;
        }

        .topbar-meta {
            display: none;
        }

        .content-inner {
            padding: 24px 16px 60px;
        }

        .mat-body {
            padding: 22px 18px;
        }

        .masthead {
            padding: 24px 20px;
        }
    }
</style>